import { asyncRoutes, constantRoutes, FASTBIPATH } from '@/router';
const state = {
  routes: [],
  addRoutes: [],
};

const mutations = {
  SET_ROUTES: (state, action) => {
    state.addRoutes = action.routes;
    state.routes = filterConstantRouter(constantRoutes, action.allow).concat(action.routes);
  },
};

function hasPermission(roles, route, actions) {
  if (route.meta && route.meta.roles) {
    //return roles.some(role => route.meta.roles.includes(role))
    return route.meta.roles.indexOf(roles) > -1;
  } else if (route.meta && route.meta.customRoles) {
    // 符合其中一个规则就显示
    let customRoles = route.meta.customRoles;

    for (const c of customRoles) {
      if (actions[c]) {
        return actions[c];
      }
    }
  } else if (route.meta && route.meta.offline) {
    return actions.allow_offline;
  }
}

function hasCRPermission(roles, route) {
  if (route.meta && Array.isArray(route.meta.roles)) {
    //return roles.some(role => route.meta.roles.includes(role))
    // return route.meta.roles.indexOf(roles) > -1
    for (const role of route.meta.roles) {
      if (role in roles && roles[role]) {
        return true;
      }
    }
    return false;
  } else {
    return true;
  }
}

function filterConstantRouter(routes, allow) {
  const res = [];
  routes.forEach((route) => {
    const tmp = { ...route };
    if (hasCRPermission(allow, tmp)) {
      if (tmp.children) {
        tmp.children = filterConstantRouter(tmp.children, allow);
      }
      res.push(tmp);
    }
  });
  return res;
}

export function filterAsyncRoutes(routes, roles, actions) {
  const res = [];
  console.log(routes)
  routes.forEach((route) => {
    const tmp = { ...route };

    if (tmp.name)
      if (hasPermission(roles, tmp, actions)) {
        if (tmp.children) {
          tmp.children = filterAsyncRoutes(tmp.children, roles, actions);
        }
        console.log(actions, 'actions')

        if (tmp.name === '小程序素材') {
          if (!actions.is_superuser) {
            if (actions.roles_operator) {
              tmp.meta.title = '小程序素材';
            } else {
              tmp.meta.title = '小程序素材';
            }
          } else {
            tmp.meta.title = '小程序素材';
          }
        } else if (tmp.name === '资料管理') {
          if (!actions.is_superuser) {
            if (actions.roles_operator) {
              tmp.meta.title = '资料管理';
            } else {
              tmp.meta.title = '资料中心';
            }
          } else {
            tmp.meta.title = '资料管理';
          }
        }
        res.push(tmp);
      }
  });

  return res;
}
const actions = {
  generateRoutes({ commit }, action) {
    return new Promise((resolve) => {
      let resultRoutes = asyncRoutes;
      /* TODO 只有管理员才能看到 *管理fastbi产品**/
      // if (!action.admin) {
      //   resultRoutes = resultRoutes.filter((i) => i.redirect !== FASTBIPATH);
      // }

      if (action['agent_info'] && action['agent_info']['roles']) {
        let r = action['agent_info']['roles']
        if (!Array.isArray(r)) {
          r = JSON.parse(r)
        } 

        r.forEach(item => {
          action[`roles_${item}`] = true
        })
      }
      if (action['agent_info'] && action['agent_info']['permissions']) {
        const r = JSON.parse(action['agent_info']['permissions']);
        for (const key in r) {
          const rv = r[key];
          if (Array.isArray(rv)) {
            rv.forEach(item => {
              action[`permissions_${key}_${item}`] = true
            })
          }

        }


      }
      let accessedRoutes = filterAsyncRoutes(resultRoutes, action.roles, action);
      commit('SET_ROUTES', {
        allow: {
          allow_oem: action.allow_oem,
          allow_offline: action.allow_offline,
          allow_xzreport: action.allow_xzreport,
          allow_af: action.allow_af,
        },
        routes: accessedRoutes,
      });
      resolve(accessedRoutes);
    });
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/permission.js